import React from "react";
import styles from "./recommendationsSection.module.scss";
import { SkeletonBase } from "@foris/avocado-suite";

const Alternatives = ({ count = 3 }: { count: number }) => (
  <div className={styles.skeletonAlternatives}>
    {Array.from({ length: count }).map((_, index) => (
      <div key={index} className={styles.skeletonAlternative}>
        <SkeletonBase className={styles.skeletonAlternative_label} width="30%" height="8px" />
        <SkeletonBase width="35%" height="24px" />
        <SkeletonBase width="35%" height="24px" />
      </div>
    ))}
  </div>
);

const RecommendationsSectionSkeleton = () => {
  return (
    <div className={styles.RecommendationsSectionSkeleton}>
      <SkeletonBase className={styles.skeletonTitle} width="100%" height="24px" />

      <SkeletonBase className={styles.skeletonSubtitle} width="100%" height="16px" />

      <div className={styles.skeletonPackages}>
        <SkeletonBase width="100%" height="8px" />
        <SkeletonBase width="100%" height="8px" />
        <SkeletonBase width="100%" height="8px" />
        <SkeletonBase width="100%" height="8px" />
      </div>

      <SkeletonBase width="100%" height="24px" />
      <SkeletonBase className={styles.skeletonTabs} width="100%" height="32px" />

      <Alternatives count={3} />

      <SkeletonBase className={styles.skeletonAlternativeSeparator} width="100%" height="1px" />

      <Alternatives count={3} />

      <SkeletonBase className={styles.skeletonAlternativeSeparator} width="100%" height="1px" />

      <Alternatives count={1} />
    </div>
  );
};

export default RecommendationsSectionSkeleton;
